<template>
  <div v-bind:class="['row', name]" style="height: 45px; padding-left: 15px;">
    <div v-bind:class="['col-2', 'corner-rl', 'd-flex', 'align-items-center', (!label? 'justify-content-around': ''), (label? 'labelRow' : 'icon')]">
      <small v-if="label">{{ label }}</small>
      <base-icon v-if="!label" v-bind:name="(icon? icon: name)" />
    </div>
    <div class="col-5">
      <div class="totalCount corner-rl d-flex align-items-center justify-content-around" style="height: 100%">
          <span class="count" style="flex-grow: 1">{{ data.count }}</span>
          <span style="flex-grow: 2"><small style="font-weight: bold">{{ data.total }}</small></span>
      </div>
    </div>
    <div class="col-5">
      <div class="totalCount corner-rl d-flex align-items-center justify-content-around" style="height: 100%">
          <span class="count" style="flex-grow: 1">{{ data.monthlyCount }}</span>
          <span style="flex-grow: 2"><small style="font-weight: bold">{{ data.monthlyAvg }}</small></span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import BaseIcon from '../../components/icons/BaseIcon.vue'

export default {
  name: 'ShippingCostRow',
  props: ['name', 'label', 'icon', 'data'],
  components: {
    BaseIcon
  },
  async mounted () {
  }, // end mounted
}

</script>


// WEBPACK FOOTER //
// ShippingCostRow.vue?eb767efc